import http from '../api/http.js';
import store from '@/store/index.js';
import router from '@/router/index';
import route from '@/router/index';
import jwt_decode from "jwt-decode";
import { Message } from 'element-ui';
import config from '../../config';

let common = {
  isUrl(url) {
    // url= 协议://(ftp的登录信息)[IP|域名](:端口号)(/或?请求参数)
    var strRegex =
      '^((https|http|ftp)://)?' + // (https或http或ftp):// 可有可无
      "(([\\w_!~*'()\\.&=+$%-]+: )?[\\w_!~*'()\\.&=+$%-]+@)?" + // ftp的user@  可有可无
      '(([0-9]{1,3}\\.){3}[0-9]{1,3}' + // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
      '|' + // 允许IP和DOMAIN（域名）
      '(localhost)|' + // 匹配localhost
      "([\\w_!~*'()-]+\\.)*" + // 域名- 至少一个[英文或数字_!~*\'()-]加上.
      '\\w+\\.' + // 一级域名 -英文或数字  加上.
      '[a-zA-Z]{1,6})' + // 顶级域名- 1-6位英文
      '(:[0-9]{1,5})?' + // 端口- :80 ,1-5位数字
      '((/?)|' + // url无参数结尾 - 斜杆或这没有
      "(/[\\w_!~*'()\\.;?:@&=+$,%#-]+)+/?)$"; // 请求参数结尾- 英文或数字和[]内的各种字符
    var re = new RegExp(strRegex, 'i'); // i不区分大小写
    // 将url做uri转码后再匹配，解除请求参数中的中文和空字符影响
    if (re.test(encodeURI(url))) {
      return true;
    }
    return false;
  },
  getImg(src, url) {
    if (this.isUrl(src)) {
      return src;
    }
    if (url) {
      if (url[url.length - 1] == "/") {
        url = url.substr(0, url.length - 1);
      }
      return url + src;
    }
    return src;
  },
  toName: (name) => {
    router.push({ name: name });
  },
  toPath: (path) => {
    router.push(path);
  },
  toBook: (id, attr) => {
    if (attr == "2") {
      location.href = "/YssDetail?Id=" + id;
      return;
    }
    location.href = "/DzsDetail?Id=" + id;
  },
  toUrl(url) {
    if (!url) {
      return;
    }
    if (this.isUrl(url)) {
      location.href = url;
      return;
    }
    router.push(url);
  },
  addFollow(item, type) {
    if (common.openLogin()) {
      return;
    }
    var sourceId = item.id;
    if (type == "stack") {
      sourceId = item.bookId;
    }
    var attr = item.attr;
    if (!attr) {
      attr = item.ProductType;
    }
    http.api.SubmitCollect({ sourceId: sourceId, sourceType: attr + 10 }).then((res) => {
      Message({ type: res.code ? "success" : "error", message: res.data });
      if (res.code != 1) {
        return;
      }
      item.isFollow = !item.isFollow;
    });
  },
  addCollect(item, type) {
    // return console.log(type);
    if (common.openLogin()) {
      return;
    }
    var sourceId = item.id;
    if (type == "stack") {
      sourceId = item.bookId;
    }
    http.api.SubmitCollect({ sourceId: sourceId, sourceType: item.attr }).then((res) => {
      Message({ type: res.code == 1 ? "success" : "warning", message: res.data });
      if (res.code != 1) {
        return;
      }
      item.isCollect = !item.isCollect;
    });
  },
  isLogin() {
    if (common.getToken()) {
      return true;
    }
    return false;
  },
  openLogin() {
    if (!common.getToken()) {
      if (config.release.loginType == 'sso')
        common.toSso();
      else
        common.showLogin();
      return true;
    }
    return false;
  },
  openJdReadBook(id, bookId, terminal, page, type, callback) {
    if (!id) {
      return;
    }
    if (common.openLogin()) {
      return;
    }
    http.api.GetJdReadBook({ id: id, page: page ? page : "", TERMINALTYPE: terminal, ebookid: bookId, type: type }).then((res) => {
      if (callback) {
        callback(res);
        return;
      }
      if (res.code != 1) {
        if (res.data == "org is null") {
          router.push({ path: "/UserInfo" });
          return Message({ message: "请先绑定机构!", type: "error" });
        }
        return Message({ message: "看书失败!", type: "error" });
      }
      //window.open(res.data);
      if (common.isIOS()) {
        location.href = res.data;
      } else {
        window.open(res.data, '_blank');
      }
    });
  },
  getBookAttrText(id) {
    if (id == 1) {
      return "电子书";
    }
    if (id == 2) {
      return "有声书";
    }
    return "其他书";
  },
  getBookOpenText(id) {
    if (id == "01") {
      return "借阅";
    }
    return "畅读";
  },
  getMember() {
    var token = common.getToken();
    if (token) {
      return jwt_decode(token);
    }
    return null;
  },
  getOrg() {
    return window.localStorage.org ? JSON.parse(window.localStorage.org) : undefined;
  },
  orgId() {
    // return "e3414dffe08b4167925cb5bf44e5ef1c";
    var org = this.getOrg()
    return org ? org.orgId : "";
  },
  schoolId() {
    var org = this.getOrg()
    return org ? org.id : "";
  },

  loadOrg: () => new Promise((resolve, reject) => {
    var org = common.getOrg();
    if (org) {
      if (org.host != location.hostname) {
        localStorage.removeItem('org');
        org = null;
      } else {
        console.log("该域名已经缓存，不需要重新加载");
      }
    }
    if (org) {
      resolve(org);
      return;
    }
    http.api.GetOrgInfoByUrl({ host: location.hostname }).then((res) => {
      if (res.code != 1) {
        return Message({ message: res.info, type: "error" });
        //return this.$router.push({ name: 'error' });
      }
      localStorage.setItem('org', JSON.stringify(res.data));
      resolve(res.data);
    });
  }),
  showLogin: (mode) => {
    store.commit('setLoginShow', true);
    store.commit('setLoginMode', mode ? mode : 1);
  },
  hideLogin: () => {
    store.commit('setLoginShow', false);
  },
  login(token, path) {
    var member = jwt_decode(token);
    if (member.orgId != this.orgId()) {
      var index = location.href.indexOf('/');
      location.href = member.domain + "/Auth?token=" + token + "&path=" + path;
      return;
    }
    this.setToken(token);
    location.href = location.href;
    // if (res.code != 1) {
    //   return Message({ type: "error", message: res.info });
    // }
    // var member = jwt_decode(res.data);
    // if (member.orgId != this.orgId()) {
    //   var index = location.href.indexOf('/');
    //   location.href = member.domain + "/Auth?token=" + res.data + "&path=" + path;
    //   return;
    // }
    // this.setToken(res.data);
    // location.href = location.href;
  },

  getLocalStorageItem(name) {
    return localStorage.getItem(name);
  },
  setLocalStorageItem(name, value) {
    localStorage.setItem(name, value);
  },
  getToken() {
    return window.localStorage.Token && window.localStorage.Token.length >= 128 ? window.localStorage.Token : null;
  },
  setToken(token) {
    localStorage.setItem('Token', token);
  },
  delToken() {
    localStorage.removeItem('Token');
  },
  getParams() {
    var url = location.href;
    if (url.indexOf("?") == -1) {
      return {};
    }
    var str = location.href.split("?")[1];
    var arr = str.split("&");
    var params = {};
    for (var i = 0; i < arr.length; i++) {
      var result = arr[i].split("=");
      if (result.length != 2) {
        continue;
      }
      params[result[0]] = result[1];
    }
    return params;
  },
  getParamFromQueryString(key) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  },
  isIOS() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipad|mac|ipod/.test(userAgent) || ['iPhone', 'iPad', 'iMac', 'iPod'].includes(navigator.platform);
  },
  toSso() {
    //西南大学直接登录
    //window.location.href = "/sso";
    var redirect = '%3fredirect%3d' + encodeURIComponent(window.location.pathname);
    //console.log(config.release.ssoUrl + redirect)
    //http://www.jdreader.net:11203/?uid=23&Source=read&ResultUrl=http://opac.cug.edu.cn/userapi/Auth/SsoLogin?redirect=/
    window.location.href = config.release.ssoUrl + redirect;
  }
};
export default common;



// WEBPACK FOOTER //
// ./src/units/common.js